import React from "react";
import { TextField, Typography, CircularProgress } from "@mui/material";
import Button from "../../../common/Button";

const CreateGroup = ({
  groupName,
  handleGroupNameChange,
  handleCreateGroup,
  handleBackStep,
  onClose,
  isLoading,
  error, // Added error prop
}) => {
  return (
    <div style={containerStyle}>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Create a new group
      </Typography>

      <TextField
        label="Group name"
        variant="outlined"
        fullWidth
        value={groupName}
        onChange={handleGroupNameChange}
        sx={{ mb: error ? 1 : 2 }}
        error={!!error}
      />

      {/* Error message display */}
      {error && (
        <Typography
          color="error"
          variant="caption"
          sx={{ mb: 2, display: "block" }}
        >
          {error}
        </Typography>
      )}

      <div style={buttonContainerStyle}>
        <Button
          onClick={handleCreateGroup}
          disabled={!groupName || isLoading}
          text={isLoading ? "Creating..." : "Create group"}
          fullWidth
          startIcon={isLoading ? <CircularProgress size={20} /> : null}
        />
        <Button
          variant="outlined"
          onClick={handleBackStep}
          text="Back"
          backgroundColor="white"
          fullWidth
          disabled={isLoading}
        />
        <Button
          variant="outlined"
          onClick={onClose}
          text="Cancel"
          backgroundColor="white"
          fullWidth
          disabled={isLoading}
        />
      </div>
    </div>
  );
};

export default CreateGroup;

const containerStyle = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
};

const buttonContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  width: "100%",
};
